import { epicRequest, serverResponse } from 'app'

export const TEAMS_LIST_FETCH = 'TEAMS_LIST_FETCH'
export const TEAMS_LIST_FETCH_ERROR = 'TEAMS_LIST_FETCH_ERROR'
export const TEAMS_LIST_FETCH_FULFILLED = 'TEAMS_LIST_FETCH_FULFILLED'
export const TEAMS_LIST_FETCH_CANCELED = 'TEAMS_LIST_FETCH_CANCELED'

export const TEAMS_LIST_LIKE = 'TEAMS_LIST_LIKE'
export const TEAMS_LIST_LIKE_ERROR = 'TEAMS_LIST_LIKE_ERROR'
export const TEAMS_LIST_LIKE_FULFILLED = 'TEAMS_LIST_LIKE_FULFILLED'
export const TEAMS_LIST_LIKE_CANCELED = 'TEAMS_LIST_LIKE_CANCELED'

export const INITIAL_STATE = serverResponse()

export const teamListFetch = (userId, page) => ({
  payload: { page, userId },
  type: TEAMS_LIST_FETCH,
})

export const teamListFetchFulfilled = (payload) => ({
  payload,
  type: TEAMS_LIST_FETCH_FULFILLED,
})

export const teamListFetchCanceled = () => ({
  payload: null,
  type: TEAMS_LIST_FETCH_CANCELED,
})

export const teamListFetchError = (payload) => ({
  payload,
  type: TEAMS_LIST_FETCH_ERROR,
})

export const teamListFetchEpic = epicRequest({
  actionType: TEAMS_LIST_FETCH,
  errorAction: teamListFetchError,
  fulfilledAction: teamListFetchFulfilled,
  request: ({ payload }) => `user/${payload.userId}/teams?page=${payload.page}`,
  untilTypes: TEAMS_LIST_FETCH_CANCELED,
})

export const teamListLike = (teamId, like) => ({
  payload: { like, teamId },
  type: TEAMS_LIST_LIKE,
})

export const teamListLikeFulfilled = (payload) => ({
  payload,
  type: TEAMS_LIST_LIKE_FULFILLED,
})

export const teamListLikeCanceled = () => ({
  payload: null,
  type: TEAMS_LIST_LIKE_CANCELED,
})

export const teamListLikeError = (payload) => ({
  payload,
  type: TEAMS_LIST_LIKE_ERROR,
})

export const teamListLikeEpic = epicRequest({
  actionType: TEAMS_LIST_LIKE,
  errorAction: teamListLikeError,
  fulfilledAction: teamListLikeFulfilled,
  request: ({ payload }) => ({
    method: payload.like ? 'post' : 'delete',
    url: `team/${payload.teamId}/${payload.like ? 'like' : 'unfollow'}`,
  }),
  untilTypes: TEAMS_LIST_LIKE_CANCELED,
})
